import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "content", "active", "index", "onClick", "activeIcon", "inactiveIcon", "className"];
import React, { useContext } from 'react';
import { Accordion as SemanticUiAccordion } from 'semantic-ui-react';
import _isBoolean from 'lodash/isBoolean';
import _isEmpty from 'lodash/isEmpty';
import { classNames } from '../../../../../../utils/classname';
import useSemanticUiProps from '../../../../hooks/use-semantic-ui-props';
import { ChildrenPropType } from '../../../../types/component';
import Icon from '../../../Icon';
import { AccordionContext } from '../../Accordion.context';
var defaultProps = {
  className: '',
  children: null,
  content: null,
  active: undefined,
  index: undefined,
  onClick: null,
  activeIcon: '',
  inactiveIcon: ''
};
export default function Title(_ref) {
  var _classNames;
  var children = _ref.children,
    content = _ref.content,
    active = _ref.active,
    index = _ref.index,
    onClickProp = _ref.onClick,
    activeIcon = _ref.activeIcon,
    inactiveIcon = _ref.inactiveIcon,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(AccordionContext),
    onTitleClick = _useContext.onTitleClick,
    activeIndexes = _useContext.activeIndexes;
  var _useSemanticUiProps = useSemanticUiProps(),
    getAccordionTitleProps = _useSemanticUiProps.getAccordionTitleProps;
  function isActive() {
    if (_isBoolean(active)) {
      return active;
    }
    return activeIndexes.includes(index);
  }
  function onClick(e, target) {
    if (onClickProp) {
      onClickProp(e, target);
    } else {
      onTitleClick(e, target);
    }
  }
  var finalActive = isActive();
  var finalClassName = classNames((_classNames = {}, _defineProperty(_classNames, className, true), _defineProperty(_classNames, "inactive", !finalActive), _classNames));
  return /*#__PURE__*/React.createElement(SemanticUiAccordion.Title, _extends({}, getAccordionTitleProps(props), {
    active: finalActive,
    index: index,
    onClick: onClick,
    className: finalClassName
  }), /*#__PURE__*/React.createElement(React.Fragment, null, content || children), finalActive && !_isEmpty(activeIcon) && /*#__PURE__*/React.createElement(Icon, {
    iconName: activeIcon
  }), !finalActive && !_isEmpty(inactiveIcon) && /*#__PURE__*/React.createElement(Icon, {
    iconName: inactiveIcon
  }));
}
Title.defaultProps = defaultProps;